import { BaseEntity } from "yt-ng-framework";

export class KursDokument extends BaseEntity{

    constructor(){
        super();
    }
    Datum: Date = null;
    Opis: string = null;
    
    

    Deserialize(input: any){
        this.ID = input.ID;       
        this.Datum = input.Datum;
        this.Opis = input.Opis;
        
        return this;
    }

    Serialize(input: KursDokument){
        return input;
    }

    GetInstance(){
        return this;
    }
}